// components/Services.js
import React from 'react';

const Services = () => {
  const services = [
    {
      title: "Solar Mini-Grid Systems",
      description: "10KW - 550KW systems for communities and businesses",
      icon: "🔆"
    },
    {
      title: "Solar Water Pumping Systems",
      description: "Portable and fixed systems with water reticulation",
      icon: "💧"
    },
    {
      title: "On-Grid Solar Systems",
      description: "5KW - 990KW grid-tied solar solutions",
      icon: "🏢"
    },
    {
      title: "Off-Grid Solar Systems",
      description: "5KW - 990KW independent power solutions",
      icon: "🏡"
    },
    {
      title: "Solar Water Heating",
      description: "Efficient solar thermal systems for hot water",
      icon: "☀️"
    },
    {
      title: "Borehole Drilling",
      description: "Complete water development solutions",
      icon: "🚜🌊🏗️"
    },
    {
      title: "Energy Auditing",
      description: "Comprehensive energy efficiency assessments",
      icon: "📊"
    },
    {
      title: "Consultancy Services",
      description: "Expert solar energy consulting",
      icon: "👨‍💼"
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>Comprehensive solar energy solutions for residential, commercial, and industrial applications.</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;